<!-- A component to display a small heading -->
<template>
	<div
		class="text-secondary-900 text-xs leading-7 font-light tracking-wider uppercase md:text-sm md:leading-8"
		:class="{
			'decoration-secondary-200 underline decoration-1 underline-offset-8':
				!noUnderline,
		}"
	>
		{{ headingText }}
	</div>
</template>

<script setup lang="ts">
defineProps({
	headingText: {
		type: String,
		required: true,
	},
	noUnderline: {
		type: Boolean,
		default: false,
	},
})
</script>
